module.exports = __webpack_public_path__ + "static/media/53 - Roudoudou - Peace and tranquility to earth.1301bc02.mp3";